import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface CookieConsent {
  analytics: boolean;
  timestamp: number;
}

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  private readonly STORAGE_KEY = 'cookie_consent';
  private _consent = new BehaviorSubject<CookieConsent | null>(this.getStoredConsent());
  consent$: Observable<CookieConsent | null> = this._consent.asObservable();

  constructor() {
    const consent = localStorage.getItem(this.STORAGE_KEY);
    if (consent) {
      this._consent.next(JSON.parse(consent));
    }
  }

  hasConsent(): boolean {
    return this._consent.value !== null;
  }

  hasAnalyticsConsent(): boolean {
    return this._consent.value?.analytics === true;
  }

  acceptAll(): void {
    const consent: CookieConsent = {
      analytics: true,
      timestamp: Date.now(),
    };
    this.saveConsent(consent);
  }

  acceptNecessaryOnly(): void {
    const consent: CookieConsent = {
      analytics: false,
      timestamp: Date.now(),
    };
    this.saveConsent(consent);
  }

  private saveConsent(consent: CookieConsent): void {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(consent));
    this._consent.next(consent);
  }

  private getStoredConsent(): CookieConsent | null {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  }
}
